import { Component, OnDestroy } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { StoreService } from '../../../../services/store.service';
import { ID_PARAM } from '../../../../config/url.config';
import { FormsService } from '../../../settings/services/forms.service';
import { Task } from '../../../go/model/task.model';
import { FormStructure } from "../../../settings/model/form.model";

@Component({
  selector: 'form-preview',
  templateUrl: './form-preview.component.html',
  styleUrls: ['./form-preview.component.scss']
})
export class FormPreviewComponent implements OnDestroy {
  config$: Observable<any>
  form: FormGroup = this.fb.group({});
  formId!: number;
  task: Task;

  constructor(
    private fb: FormBuilder,
    private formsService: FormsService,
    private route: ActivatedRoute,
    private store: StoreService
  ){
    this.store.showLoader();
    this.formId = this.route.snapshot.params[ID_PARAM];
    this.config$ = this.formsService.getForm(this.formId).pipe(
      tap(() => this.store.hideLoader()),
      tap(data => this.setTask(data))
    );
    this.store.hideProjectSelector()
  }
  ngOnDestroy() {
    this.store.showProjectSelector();
  }

  setTask(data: FormStructure) {
    this.task = {
      copiedFrom: 111,
      isValid: true,
      templateImplementationVersion: data.implementationVersion,
      id: 99999,
      createdBy: null,
      createdOn: '2024-12-31',
      modifiedBy: null,
      modifiedOn: null,
      assignedOn: null,
      assignedBy: null,
      assignedTo: null,
      name: 'TASK',
      plannedExecutionDate: '2024-12-31',
      status: 'DRAFT',
      blocked: false,
      pseStatus: null,
      pseVerificationDescription: 'Brak zdjęcia tabliczki znamionowej słupa. Uzupełnij dokumentację fotograficzną.',
      pseSyncStatus: null,
      pseSentOn: null,
      assignees: [],
      project: {
        id: 'XXXXX',
        permissions: [],
        projection: {
          type: 'EPSG',
          srid: 2180,
          proj: '',
          wkt: ''
        },
        actionsCount: 0,
        name: 'TEST'
      },
      order: {
        multiTrackLine: false,
        pseFanOutInProgress: false,
        id: 99999,
        source: 'ENPROM',
        hasSkmsDiscrepancy: false,
        inspectionCardStatus: 'UNSET',
        missingSkmsNumbers: [],
        externalSpanIds: [],
        externalTowerIds: [],
        canClose: false,
        hasCancelledTasks: false,
        name: 'ORDER',
        status: 'IN_PROGRESS',
        pseStatus: null,
        dataType: 'BOTH',
        filters: [],
        assignedTo: [],
        plannedExecutionDate: '2024-12-31',
        towers: [],
        spans: [],
        project: {
          id: 'XXXXX',
          permissions: [],
          projection: {
            type: 'EPSG',
            srid: 2180,
            proj: '',
            wkt: ''
          },
          actionsCount: 0,
          name: 'TEST'
        },
        createdOn: '2024-01-01',
        createdBy: {
          id: '000',
          email: 'jon.snow@enprom.pl',
          userName: 'jon.snow@enprom.pl',
          firstName: 'Jon',
          lastName: 'Snow',
        },
        modifiedOn: null,
        modifiedBy: null,
        towerForm: null,
        spanForm: null,
        readyToExecute: true,
        spanCount: 0,
        towerCount: 0
      },
      filters: '',
      form: undefined,
      formValues: undefined,
      type: 'SPAN',
      line: null,
      span: null,
      tower: null,
      localVersion: false,
      failureCount: 0,
      historicalFailureCodes: [],
      historicalFailuresFrom: '2024-01-01',
      historicalFailuresTo: '2025-01-01'
    }
  }
}
